import * as v from 'valibot';

export * from './projects.model';
export * from './sorting-options.model';

export const projectBaseApiSchema = v.object({});
